import { localizedText } from '../types/slide-doc';
import type { DeckDoc } from '../types/slide-doc';

interface Props {
  deck: DeckDoc;
  activeChapterId: string | null;
}

export function ChapterRibbon({ deck, activeChapterId }: Props) {
  if (!deck.chapters || deck.chapters.length === 0) return null;
  const ch = deck.chapters.find((c) => c.id === activeChapterId);
  if (!ch) return null;
  return (
    <div style={style}>
      <div style={dot} />
      <div style={label}>{localizedText(ch.title)}</div>
    </div>
  );
}

const style: React.CSSProperties = {
  position: 'fixed',
  top: 18,
  left: 18,
  display: 'flex',
  alignItems: 'center',
  gap: 10,
  padding: '8px 14px',
  background: 'rgba(15,25,35,0.66)',
  color: '#F5B800',
  borderRadius: 999,
  fontFamily: 'Inter, sans-serif',
  fontWeight: 600,
  fontSize: 14,
  letterSpacing: 0.6,
  textTransform: 'uppercase',
  backdropFilter: 'blur(8px)',
  border: '1px solid rgba(245,184,0,0.18)',
  zIndex: 20,
  pointerEvents: 'none',
};

const dot: React.CSSProperties = {
  width: 8,
  height: 8,
  borderRadius: 4,
  background: '#F5B800',
  boxShadow: '0 0 8px #F5B800',
};

const label: React.CSSProperties = {
  color: '#fff',
};
